import React, { useState, useEffect } from "react";
import { isAuthenticated } from "@/api/localStorage";
import HeaderDesktop from "./Desktop/HeaderDesktop";
import Styles from "./Header.module.scss";
import { HeaderMobile } from "./Mobile/HeaderMobile";
import { ImpersonateBanner } from "@/auth/components/Impersonate/Banner";

const Header = () => {
  const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 1279px)").matches);
  const isUserAuthenticated = isAuthenticated();

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 1279px)");
    const handleChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handleChange);
    } else if (mediaQuery.addListener) {
      // Fallback to addListener for older browsers
      mediaQuery.addListener(handleChange);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", handleChange);
      } else if (mediaQuery.removeListener) {
        // Fallback for older browsers
        mediaQuery.removeListener(handleChange);
      }
    };
  }, []);

  return (
    <div className={Styles.headerStickyWrapper}>
      <nav className={Styles.headerInlineSticky} aria-label="main-nav-bar">
        {isUserAuthenticated && <ImpersonateBanner />}
        {isMobile ? <HeaderMobile /> : <HeaderDesktop />}
      </nav>
    </div>
  );
};

export default Header;
